<div class="d-block d-lg-none"><fgb-page-header [pageTitle]="'rewards.page.title'"></fgb-page-header></div>
<div *ngIf="lottoItem; else noPurchase">
  <div class="d-block d-lg-flex border-0 rounded overflow-hidden mt-lg-4 mt-1 justify-content-center align-items-center">
    <div class="item-details d-flex flex-column align-items-center flex-grow-1 flex-shrink-1 p-3">
      <div class="d-lg-flex d-block">
        <div>
          <div class="text-success mb-0 fw-bold font-size-18 text-start mb-1">
            {{ 'lotto.entry.successful' | translate }}
          </div>
          <p class="mb-0 text-black font-size-14 pe-lg-4 lotto-success-description">
            <ng-container>{{ 'lottos.purchase.confirm' | translate }}</ng-container>
          </p>
          <div class="d-flex border-0 mt-4">
            <a class="btn btn-primary confirm-btn fw-bold text-white" [routerLink]="['/rewards/wallet']">{{
              'rewards.back.to.wallet' | translate
            }}</a>
          </div>
        </div>
        <div class="border rounded payment-details">
          <div class="d-lg-flex d-block">
            <img
              class="purchase-success-image rounded"
              src="{{ lottoItem.ImageName | contentImage: '6' : 'lotto' }}"
              alt="{{ lottoItem.ImageName }}"
              [useDefault]="true"
              [loyaltyTyps]="'lotto'"
              draggable="false"
            />
            <div>
              <!--Name-->
              <div class="font-size-12 mb-3 fw-bold font-size-14">{{ lottoItem.Title }}</div>
              <!--Quantity-->
              <div class="d-flex align-items-start mt-2">
                <span class="font-size-12 lotto-details-spacing">{{ 'lotto.entries' | translate }}</span>
                <span class="fw-bold font-size-14 ps-2">{{ quantity | number }}</span>
              </div>
              <!--Price-->
              <div class="d-flex align-items-start mt-2">
                <span class="font-size-12 lotto-details-spacing">{{ 'lotto.points.used' | translate }}</span>
                <span class="fw-bold font-size-14 ps-2"
                  >{{ totalPrice | number }} {{ 'lottos.points.value.pts' | translate }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noPurchase>
  <div class="text-center m-5">No raffles found...</div>
</ng-template>
